import PanelLayout from "src/Layout/PanelLayout";
import Button from "src/components/Button";

export default function JobAnalysisPageHelp({ handleStep }) {
    return (
        <PanelLayout>
            <div className="flex flex-col justify-center items-center h-[80vh]">
                <div className="w-[900px] flex flex-col gap-4 shadow-md rounded bg-white p-10 border border-solid border-gray-200">
                    <span>با سلام</span>
                    <p>
                        با توجه به نقش تجزیه و تحلیل و طراحی استاندارد مشاغل در فرایندهای توسعه مدیریت منابع انسانی و الزامات جهت گیری استراتژیک برنامه های توسعه سرمایه های انسانی سازمان، خواهشمند است با توجه به شناختی که نسبت به هر یک از مشاغل دارید فرم های زیر را تکمیل نمایید.
                        در فرایند تکمیل اطلاعات به موارد زیر توجه نمایید:
                    </p>
                    <p>
                        اطلاعات درج شده در هر قسمت بایستی متناسب با عنوان آن شغل باشد نه فردی که در حال حاضر متصدی آن شغل است.
                        برای شروع  از قسمت اول اقدام به ثبت اطلاعات نموده و در انتهای هر قسمت با کلیک بر روی دکمه ثبت اطلاعات (در انتهای هر فرم) مجدد به صفحه حاضر هدایت خواهید شد و می توانید برای ادامه قسمت بعدی را انتخاب کرده و اطلاعات لازم را درج نمایید.
                        لازم است در ابتدای هر قسمت عنوان شغل و کد مربوطه را مجدد وارد نمایید لذا توجه شود که کد های وارد شده در همه قسمت ها برای یک شغل دقیقاً یکسان باشد.
                        از آنجاییکه اطلاعات درج شده فقط زمانی ذخیره می گردد که فرم مربوطه بطور کامل تکمیل شده و در انتهای فرم کلید ثبت اطلاعات کلیک شود لذا زمانی که هر قسمتی را انتخاب کردید تا تکمیل کامل اطلاعات همان قسمت از سیستم خارج نشوید.
                    </p>
                    <span>
                        برای اطلاعات بیشتر <a className="text-blue-700" href="assets/pdf/help.pdf">فایل راهنما</a> را مطالعه کنید
                    </span>
                    <div className="flex flex-row justify-center items-center">
                        <button onClick={() => { handleStep(0) }} className="bg-main-color p-2 px-6 rounded text-white">
                            شروع
                        </button>
                    </div>
                </div>
            </div>
        </PanelLayout>
    )
}